<template>
    <div class="position-relative c-bike-tag__wrap" :class="!listProduct ? 'd-flex justify-center' : ''">
        <div class="c-bike-tag d-inline-flex align-center text-small bg-white" :class="[selected.color, !listProduct ? 'transform border pa-1' : '']">
            <v-icon :icon="selected.icon"></v-icon>
            <span class="ml-1">{{selected.label.value || selected.label}}</span>
        </div>
    </div>
</template>

<script setup>
import {mdiCheck, mdiClose, mdiAtv, mdiShapeOutline} from "@mdi/js";
import {computed} from "vue";
import {useDisplay} from "vuetify";
import {usePage} from "@inertiajs/vue3";
import {trans} from "laravel-vue-i18n";

const props = defineProps({
    listProduct: {
        type: Boolean,
        default: false
    },
    product: Object
})

const selected = computed(() => {
    if(props.product){
        if(props.product.is_universal === 'Y') return types.value.universal;
        const solveType = (key) => {
            if (usePage().props.modelSearch?.model?.name) {
                return props.product[key] ? types.value.known : types.value.notCompatible;
            }
            return null;
        }
        if('is_compatible' in props.product) {
            return solveType('is_compatible') || types.value.unknown;
        }
        if('backup_compatibility' in props.product) {
            return solveType('backup_compatibility') || types.value.unknown;
        }
    }
    return types.value.unknown
})

const {mdAndDown} = useDisplay();
const types = computed(() => {
    return {
        'universal': {
            icon: mdiShapeOutline,
            label: trans('category-alert.universal'),
            color: 'text-purple',
        },
        'known': {
            icon: mdiCheck,
            label: computed(() => trans('category-alert.pass', { 'model': usePage().props.modelSearch?.model?.full_name})),
            color: 'text-green',
        },
        'notCompatible': {
            icon: mdiClose,
            label: computed(() => trans('category-alert.not_compatible', { 'model': usePage().props.modelSearch?.model?.full_name})),
            color: 'text-red',
        },
        'unknown': {
            icon: mdiAtv,
            label: computed(() => {
                return mdAndDown.value ? trans('category-alert.enter_bike') : trans('category-alert.enter_bike_compatibility')
            }),
            color: 'text-blue',
        }
    }
})
</script>

<style scoped lang="scss">
.c-bike-tag__wrap {
    z-index: 9999;
}
.c-bike-tag.transform{
    border-radius: var(--motonet-border-radius);
    transform: translate3d(0, -50%, 0);
    z-index: 1;
}
</style>
